import { ClientForDetailsWithRecommendedObservationFragment } from "@acto/gql/graphql";
import { Customer, Observation } from "@acto/taskpane/core/domain";
import type { ClientForCustomer } from "@acto/taskpane/core/domain/Customer";

type ClientWithOptionalRevenue = ClientForDetailsWithRecommendedObservationFragment &
  Partial<Pick<ClientForCustomer, "revenue" | "profit" | "orderCount" | "margin">>;

export function mapClientToCustomer(client: ClientWithOptionalRevenue): Customer {
  const customer = Customer.fromGraphql(client);

  if (client.todaysRecommendedObservation) {
    const observation = Observation.fromGraphqlForCustomer(client.todaysRecommendedObservation, customer);
    customer.setObservation(observation);
  }

  return customer;
}
